import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex justify-center" }, [
        _vm.worksheet.jobId
          ? _c("div", { staticClass: "text-center font-weight-light" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.job")) +
                  ": "
              ),
              _c("a", { on: { click: _vm.assignJob } }, [
                _vm._v(_vm._s(_vm.worksheet.jobName)),
              ]),
            ])
          : _c(
              "div",
              [
                _c(
                  VBtn,
                  { attrs: { text: "" }, on: { click: _vm.assignJob } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$vuetify.lang.t("$vuetify.worksheet.assign2Job")
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
      ]),
      _c(
        VSubheader,
        { staticClass: "d-flex justify-space-between pt-4" },
        [
          _vm.worksheetTypeFields.hasTargetWeight
            ? _c(
                "div",
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        color: _vm.remainingWeight > 0 ? "red" : "green",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.showWeightStatus = true
                        },
                      },
                    },
                    [
                      _vm.remainingWeight >= 0
                        ? _c(
                            "div",
                            { staticClass: "d-flex flex-column flex-sm-row" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatNumber")(_vm.remainingWeight)
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.productInfo
                                        ? _vm.productInfo.measureWeight
                                        : ""
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$vuetify.lang.t("$vuetify.base.remain")
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "d-flex flex-column flex-sm-row" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      Math.abs(_vm.remainingWeight)
                                    )
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.productInfo
                                        ? _vm.productInfo.measureWeight
                                        : ""
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t("$vuetify.base.over")
                                    )
                                ),
                              ]),
                            ]
                          ),
                    ]
                  ),
                  _c(
                    VSnackbar,
                    {
                      attrs: {
                        timeout: _vm.timeout,
                        color: "primary",
                        "multi-line": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function ({ attrs }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._b(
                                    {
                                      attrs: { text: "", dark: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showWeightStatus = false
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  [_c(VIcon, [_vm._v("mdi-close")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        909557718
                      ),
                      model: {
                        value: _vm.showWeightStatus,
                        callback: function ($$v) {
                          _vm.showWeightStatus = $$v
                        },
                        expression: "showWeightStatus",
                      },
                    },
                    [
                      _vm.remainingWeight >= 0
                        ? _c("span", [_vm._v(_vm._s(_vm.targetRemainStatus))])
                        : _c("span", [_vm._v(_vm._s(_vm.targetOverStatus))]),
                    ]
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "text-h5 font-weight-bold" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("formatNumber")(_vm.sum.netWeight)) +
                    " " +
                    _vm._s(
                      _vm.productInfo ? _vm.productInfo.measureWeight : ""
                    ) +
                    " "
                ),
              ]),
          _vm.worksheet.locationName
            ? _c(VDivider, { attrs: { vertical: "" } })
            : _vm._e(),
          _c("div", { staticClass: "text-right" }, [
            _vm.worksheet.vehiclePlateNumber
              ? _c("div", [
                  _vm._v(" " + _vm._s(_vm.worksheet.vehiclePlateNumber) + " "),
                ])
              : _vm._e(),
            _vm.worksheet.locationName
              ? _c("div", [_vm._v(_vm._s(_vm.worksheet.locationName))])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "custom-dialog",
        {
          attrs: { fullscreen: true },
          model: {
            value: _vm.assignJobDialog,
            callback: function ($$v) {
              _vm.assignJobDialog = $$v
            },
            expression: "assignJobDialog",
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " Assign worksheet " + _vm._s(_vm.worksheet.id) + " to Job "
            ),
          ]),
          _c(
            "template",
            { slot: "default" },
            [
              _c("choose-job", {
                on: {
                  deleted: _vm.jobDeleted,
                  selected: _vm.updateWorksheetJob,
                },
                model: {
                  value: _vm.worksheet.jobId,
                  callback: function ($$v) {
                    _vm.$set(_vm.worksheet, "jobId", $$v)
                  },
                  expression: "worksheet.jobId",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }